import script from "./security-protection.vue?vue&type=script&setup=true&lang=ts"
export * from "./security-protection.vue?vue&type=script&setup=true&lang=ts"

import "./security-protection.vue?vue&type=style&index=0&id=36182e41&lang=scss&scoped=true"

import exportComponent from "/data/build/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-36182e41"]])

export default __exports__